import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#A7A7B1",
      "stroke-width": ".94",
      d: "M6 9.051a3.84 3.84 0 1 0 0-7.68 3.84 3.84 0 0 0 0 7.68Z",
      style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "6",
      cy: "7.981",
      fill: "#6E6E7D",
      rx: ".72",
      ry: ".18",
      style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6E6E7D",
      d: "M4.038 9.867a1.2 1.2 0 0 1-.211.182l-.047.032-.052.022a.2.2 0 0 0-.112.123c-.05.133.023.262.117.3.622.246 1.412.392 2.267.392.856 0 1.646-.146 2.268-.393.094-.037.166-.166.117-.299a.2.2 0 0 0-.113-.123l-.051-.022-.047-.032a1.2 1.2 0 0 1-.211-.182A4.9 4.9 0 0 1 6 10.28c-.696 0-1.36-.147-1.962-.412",
      style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }